import { useState } from "react";
import Modal from "../shared/Modal";
import { useSelector, useDispatch } from "react-redux";
import { selectUser, setCollections } from "../../redux/features/appData/";
import { toast } from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import "./ModalCollectionDelete.css";
import { apiDeleteCollection } from "../../services/CollectionService";
import { apiGetWorkspaceCollectionsForUser } from "../../api";

type ModalCollectionDeleteProps = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  collectionId: string;
};

const ModalCollectionDelete = ({
  isOpen,
  onClose,
  onDelete,
  collectionId,
}: ModalCollectionDeleteProps) => {
  const dispatch = useDispatch();
  const storeUser = useSelector(selectUser);

  const [confirmText, setConfirmText] = useState<string>("");

  if (!isOpen) {
    return null;
  }

  const handleDelete = async () => {
    const collection = await apiDeleteCollection(collectionId);

    if (!collection) {
      toast("Problem deleting collection.", toastFail);
    } else {
      if (storeUser?.currentWorkspaceId) {
        const newCollections = await apiGetWorkspaceCollectionsForUser({
          workspaceId: storeUser?.currentWorkspaceId || "",
          userId: storeUser?.id || "",
        });
        dispatch(setCollections(newCollections));
      }

      toast("Deleted collection.", toastSuccess);
      onClose();
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-delete">
          <div className="modal-collection-delete-title">Confirm Delete</div>

          <div className="modal-collection-delete-content">
            To delete this collection and remove all document resources from
            Winslow AI, please type "DELETE" below.
          </div>

          <div className="modal-collection-delete-confirm">
            <input
              autoFocus={true}
              className="modal-collection-delete-confirm-input"
              type="text"
              value={confirmText}
              onChange={(e: any) => setConfirmText(e.target.value)}
              onKeyDown={(e: any) => {
                if (
                  e.key === "Enter" &&
                  confirmText.toLowerCase() === "delete"
                ) {
                  handleDelete();
                }
              }}
            />
          </div>

          <div className="edit-tag-name-footer">
            <div className="edit-tag-name-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                disabled={confirmText.toLowerCase() !== "delete"}
                onClick={handleDelete}
                className="collections-button">
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalCollectionDelete;
